__webpack_require__.p = "//static.headai.io/influencer-platform/";